import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from 'react-router-dom';
import { GraphQL } from './components/graphql/GraphQL';
import Auth from './Auth/Auth';
import App from './App';
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import 'typeface-rubik';
import 'typeface-roboto';
//import { GAListener } from './components/GAListener/GAListener';

require('./initializers/Yup');

const auth = new Auth();

ReactDOM.render(
  <Router>
    {/*<GAListener>*/}
      <I18nextProvider i18n={i18n}>
        <GraphQL>
          <App auth={auth} />
        </GraphQL>
      </I18nextProvider>
    {/*</GAListener>*/}
  </Router>,
  document.getElementById('root')
);
